import { createTheme } from '@material-ui/core/styles'
import 'fontsource-quicksand/300-normal.css' // light
import 'fontsource-quicksand/400-normal.css' // regular
import 'fontsource-quicksand/500-normal.css' // medium
import 'fontsource-quicksand/700-normal.css' // bold

const theme = createTheme({
  palette: {
    primary: { main: '#2CCEC4', light: '#70FFF7', dark: '#009C94', contrastText: '#fff' },
    secondary: { main: '#FFAB00', light: '#FFDD4B', dark: '#C67C00', contrastText: '#fff' },
  },
  typography: { fontFamily: 'quicksand' },
  props: {
    MuiTextField: {
      variant: 'outlined'
    }
  }
})

export default theme
